import { useState } from "react";
import { validateEan, validateLocation } from "../utils";
import axios from "axios";

import CONFIG from '../config.json';
import { useCookies } from "react-cookie";
import { Locations, Location } from "../ui";
import { Label } from "../components/Label";

export const useCreateLogic = () => {

    const [errorMessage, setErrorMessage] = useState('');
    const [data, setData] = useState<{ location: string, eans: string[] }>();
    const [eansField, setEansField] = useState('');
    const [locationField, setLocationField] = useState('');

    const [cookie, setCookie, removeCookie] = useCookies(['access_key']);

    const createPalletLocation = () => {
        if (!validateFields()) {
            setData(undefined);
            return;
        }
        setErrorMessage('');
        axios.post(CONFIG.API, {
            eans: eansField.split(','),
            location: locationField,
            accessKey: cookie.access_key
        }).then((res) => {
            setData({
                eans: res.data.eans,
                location: res.data.location
            });
        }).catch((err) => {
            if (!err.response) {
                setErrorMessage('Server error, try again');
                return;
            }
            setErrorMessage(err.response.data.message);
            setData(undefined);
        });
    }

    const validateFields = () => {
        if (!eansField) {
            setErrorMessage('Podaj przynajmniej jeden EAN');
            return false;
        }
        if (!validateLocation(locationField)) {
            setErrorMessage('Podaj lokalizację w prawidłowym formacie');
            return false;
        }
        let eans = eansField.split(',');
        for (let ean of eans) {
            if (!validateEan(ean)) {
                setErrorMessage('Popraw EAN: ' + ean);
                return false;
            }
        }
        let duplicates = eans.filter((ean, index) => eans.indexOf(ean) !== index);
        if (duplicates.length > 0) {
            setErrorMessage('Wykryto duplikaty: ' + duplicates);
            return false;
        }
        return true;
    }

    function showData() {
        if (!data) return;
        return (
            <>
                <Label>{data.location}</Label>
                <Locations>{data.eans.map(ean => <Location key={ean}>{ean}</Location>)}</Locations>
            </>
        )
    }

    return { createPalletLocation, errorMessage, data, showData, setEansField, setLocationField }
}